(function () {
  var root = document.querySelector('[data-gumball-reveal]');
  if (!root) return;

  var totalTaps = parseInt(root.dataset.tapCount, 10) || 8;
  var bubble = root.querySelector('[data-gumball-reveal-bubble]');
  var prompt = root.querySelector('[data-gumball-reveal-prompt]');
  var prize = root.querySelector('[data-gumball-reveal-prize]');
  var particles = root.querySelector('[data-gumball-reveal-particles]');
  var closeBtn = root.querySelector('[data-gumball-reveal-close]');
  var codeEl = root.querySelector('[data-gumball-reveal-code]');
  var dots = root.querySelectorAll('.gumball-reveal__dot');
  var trigger = document.querySelector('[data-gumball-reveal-trigger]');
  var overlay = root.querySelector('[data-gumball-reveal-overlay]');

  var taps = 0;
  var popped = false;
  var open = false;
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SESSION_KEY = 'gumball-reveal-dismissed';

  function show() {
    if (sessionStorage.getItem(SESSION_KEY)) return;
    root.hidden = false;
    open = true;
    document.body.classList.add('gumball-reveal-locked');
    bubble.focus();
    updateBubble();
  }

  function dismiss() {
    root.hidden = true;
    open = false;
    document.body.classList.remove('gumball-reveal-locked');
    sessionStorage.setItem(SESSION_KEY, '1');
  }

  function updateBubble() {
    var progress = Math.min(taps / totalTaps, 1);
    var scale = 1 + progress * 3.5;
    bubble.style.setProperty('--bubble-scale', 'scale(' + scale + ')');
    bubble.style.transform = 'scale(' + scale + ')';

    bubble.setAttribute(
      'aria-label',
      'Blow bubble, ' + Math.min(taps, totalTaps) + ' of ' + totalTaps
    );

    for (var i = 0; i < dots.length; i++) {
      if (i < taps) {
        dots[i].classList.add('is-filled');
      } else {
        dots[i].classList.remove('is-filled');
      }
    }

    if (progress >= 0.85 && !popped) {
      bubble.classList.add('is-wobbling');
    }
  }

  function tapBubble() {
    if (popped) return;

    taps++;

    if (prefersReducedMotion) {
      taps = totalTaps;
    }

    if (navigator.vibrate) {
      navigator.vibrate(30);
    }

    bubble.classList.remove('is-tapped');
    void bubble.offsetWidth;
    bubble.classList.add('is-tapped');

    updateBubble();

    if (taps >= totalTaps) {
      pop();
    }
  }

  function pop() {
    popped = true;
    sessionStorage.setItem(SESSION_KEY, '1');
    bubble.classList.remove('is-wobbling', 'is-tapped');
    bubble.classList.add('is-popping');
    prompt.classList.add('is-hidden');

    spawnParticles();

    setTimeout(function () {
      bubble.hidden = true;
      var progressEl = root.querySelector('[data-gumball-reveal-progress]');
      if (progressEl) progressEl.hidden = true;

      prize.hidden = false;

      var prizeHeading = prize.querySelector('.gumball-reveal__prize-heading');
      if (prizeHeading) prizeHeading.focus();
    }, 450);
  }

  function spawnParticles() {
    var colors = ['#f4b8d8', '#ff69b4', '#ede5d5', '#ff91c8', '#ffd1e8'];
    var count = 12;

    for (var i = 0; i < count; i++) {
      var el = document.createElement('span');
      el.className = 'gumball-reveal__particle';

      var angle = (Math.PI * 2 * i) / count + (Math.random() - 0.5) * 0.5;
      var dist = 80 + Math.random() * 60;
      var px = Math.cos(angle) * dist;
      var py = Math.sin(angle) * dist;

      el.style.setProperty('--px', px + 'px');
      el.style.setProperty('--py', py + 'px');
      el.style.background = colors[i % colors.length];
      el.style.width = (6 + Math.random() * 8) + 'px';
      el.style.height = el.style.width;

      particles.appendChild(el);
      void el.offsetWidth;
      el.classList.add('is-active');
    }
  }

  // Copy discount code on click
  if (codeEl) {
    codeEl.addEventListener('click', function () {
      var code = codeEl.textContent.trim().replace(/ — copied!$/, '');
      if (navigator.clipboard) {
        navigator.clipboard.writeText(code).then(function () {
          codeEl.classList.add('is-copied');
          setTimeout(function () {
            codeEl.classList.remove('is-copied');
          }, 2000);
        });
      }
    });
  }

  // Bubble tap
  bubble.addEventListener('pointerdown', function (e) {
    e.preventDefault();
    tapBubble();
  });

  // Close
  closeBtn.addEventListener('click', dismiss);

  // Close on overlay background click
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) dismiss();
  });

  // Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && open) dismiss();
  });

  // Trigger button
  if (trigger) {
    trigger.addEventListener('click', show);
  }

  // Auto-popup mode
  var triggerMode = root.dataset.triggerMode || 'auto-popup';
  if (triggerMode === 'auto-popup' && !sessionStorage.getItem(SESSION_KEY)) {
    var delay = (parseInt(root.dataset.popupDelay, 10) || 3) * 1000;
    setTimeout(show, delay);
  }
})();
